// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__uOnso","location":"Header_location__2PJw4"};